<template>
  <div id="app">
    <v-app>
      <div class="page-main">

		<!--aside open-->
		<aside v-if="$user != null" class="app-sidebar">
			<div class="app-sidebar__logo">
				<a class="header-brand" @click="$router.push('dashboard')">
					<img src="/images/brand/logo.png" class="header-brand-img desktop-lgo" alt="Enjoy the Street">
					<img src="/images/brand/logo.png" class="header-brand-img dark-logo" alt="Enjoy the Street">
					<img src="/images/brand/favicon.png" class="header-brand-img mobile-logo" alt="Enjoy the Street">
					<img src="/images/brand/favicon1.png" class="header-brand-img darkmobile-logo" alt="Enjoy the Street">
				</a>
				<!-- Menüschalter sitzt am Seitenstreifen statt in der Kopfzeile (Ronny, 2026-08-05) -->
				<div class="app-sidebar__toggle sidebar-toggle-left" data-bs-toggle="sidebar" title="Menü ein- und ausklappen">
					<a class="open-toggle" href="javascript:void(0);">
						<svg xmlns="http://www.w3.org/2000/svg" class="feather feather-align-left header-icon" width="24" height="24" viewBox="0 0 24 24"><path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/></svg>
					</a>
				</div>
			</div>
			<!--
				Menü aus menuSections aufgebaut (siehe data): thematisch gruppiert,
				jeder Eintrag in einem eigenen li. Zuvor lagen alle Verwaltungs-Links
				in einem einzigen li und trugen den Aufklapp-Pfeil eines Untermenüs,
				das es nie gab.
			-->
			<ul class="side-menu app-sidebar3">
				<template v-for="section in menuSections">
					<li class="side-item side-item-category" v-bind:key="section.title">{{ section.title }}</li>
					<li class="slide" v-for="entry in section.entries" v-bind:key="entry.route">
						<a class="side-menu__item"
							v-bind:class="{ active: isActiveRoute(entry.route) }"
							v-bind:title="entry.hint"
							@click="goToRoute(entry.route)"
							data-bs-toggle="sidebar-mobile" href="javascript:void(0);">
							<v-icon class="side-menu__icon" size="18">{{ entry.icon }}</v-icon>
							<span class="side-menu__label">{{ entry.label }}</span>
						</a>
					</li>
				</template>
			</ul>
		</aside>
		<!--aside closed-->

		<!-- App-Content -->
		<div class="app-content main-content">
			<div class="side-app">

				<!--app header-->
				<div v-if="$user != null" class="app-header header main-header1">
					<div class="container-fluid">
						<div class="d-flex">
							<a class="header-brand" href="index.html">
								<img src="/images/brand/logo.png" class="header-brand-img desktop-lgo" alt="ETS logo">
								<img src="/images/brand/logo.png" class="header-brand-img dark-logo" alt="ETS logo">
								<img src="/images/brand/favicon.png" class="header-brand-img mobile-logo" alt="Enjoy the Street">
								<img src="/images/brand/favicon1.png" class="header-brand-img darkmobile-logo" alt="Enjoy the Street">
							</a>
							<div class="mt-1 d-md-block d-none" style="flex:1 1 auto;display:flex!important;align-items:center;justify-content:center;">
								<form class="form-inline">
									<div class="search-element" style="position:relative;top:0;margin:0;">
										<input type="search" class="form-control header-search mobile-view-search" placeholder="Suchen: Nutzer, Veranstaltungen, Touren …" aria-label="Suche" tabindex="1" v-model="search" style="min-width:600px;width:70vw;max-width:1050px;height:40px;border:none;border-radius:10px;background:#fff;color:#111;padding-left:52px;font-weight:600;box-shadow:0 1px 3px rgba(0,0,0,.18);">
										<a class="btn btn-primary btn-lg" @click="closeSearchMenu()" v-if="search.length > 1" style="top:50%;transform:translateY(-50%);"><i class="fas fa-times"></i></a>
										<button class="btn btn-primary-color" v-if="search.length < 2" style="top:50%;transform:translateY(-50%);color:#111;">
											<svg xmlns="http://www.w3.org/2000/svg" class="header-icon search-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" style="color:#111" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="16.2" y1="16.2" x2="21" y2="21"></line></svg>
										</button>
									</div>
								</form>
							</div><!-- SEARCH -->
							<div class="d-flex order-lg-2 ms-auto main-header-end">
								<button  class="navbar-toggler navresponsive-toggler d-md-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent-4" aria-controls="navbarSupportedContent-4" aria-expanded="true" aria-label="Menü ein- und ausblenden">
									<i class="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
								</button>
								<div class="navbar navbar-expand-lg navbar-collapse responsive-navbar p-0">
									<div class="collapse navbar-collapse" id="navbarSupportedContent-4">
										<div class="d-flex order-lg-2">
											<div class="dropdown d-lg-none d-flex responsive-search">
												<a href="javascript:void(0);" class="nav-link icon" data-bs-toggle="dropdown">
													<svg xmlns="http://www.w3.org/2000/svg" class="header-icon search-icon" width="24" height="24" viewBox="0 0 24 24"><path d="M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"/></svg>
												</a>
												<div class="dropdown-menu header-search dropdown-menu-start">
													<div class="input-group w-100 p-2">
														<input type="text" class="form-control" placeholder="Suchen ..." v-model="search">
														<button class="btn btn-primary-color" @click="closeSearchMenu();log()" type="submit">
															<svg xmlns="http://www.w3.org/2000/svg" class="header-icon search-icon p-1 mt-1" width="24" height="24" viewBox="0 0 24 24"><path d="M10 18a7.952 7.952 0 0 0 4.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0 0 18 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z"/></svg>
														</button>
													</div>
												</div>
											</div><!-- SEARCH -->
											<!-- ENTS-6: Fullscreen-, Nachrichten- und Benachrichtigungs-Platzhalter entfernt -->
												<div class="dropdown profile-dropdown d-flex">
												<a href="javascript:void(0);" class="nav-link pe-0 leading-none" data-bs-toggle="dropdown">
													<span class="header-avatar1">
														<!-- ENTS-6: Fallback, wenn kein Profilbild vorhanden ist oder der Ladevorgang fehlschlägt -->
														<img :src="$user.image ? ($user.image.startsWith('http') ? $user.image : `${$img($user.image,$awsSmallImages)}`) : '/images/brand/favicon.png'" @error="$event.target.src = '/images/brand/favicon.png'" alt="Profilbild" class="avatar avatar-md brround">
													</span>
												</a>
												<div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow animated">
													<div class="text-center">
														<div class="text-center user pb-0 font-weight-bold">{{ $user.userName }}</div>
														<span class="text-center user-semi-title">{{ $user.email }}</span>
														<div class="dropdown-divider"></div>
													</div>
													<!-- <a class="dropdown-item d-flex" href="profile-1.html">
														<svg class="header-icon me-2" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"/></svg>
														<div class="fs-13">Profile</div>
													</a>
													<a class="dropdown-item d-flex" href="search.html">
														<svg class="header-icon me-2" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>
														<div class="fs-13">Settings</div>
													</a>
													<a class="dropdown-item d-flex" href="chat.html">
														<svg class="header-icon me-2" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h12v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"/></svg>
														<div class="fs-13">Messages</div>
													</a> -->
													<a class="dropdown-item d-flex" @click="logout()">
														<svg class="header-icon me-2" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><g><rect fill="none" height="24" width="24"/></g><g><path d="M11,7L9.6,8.4l2.6,2.6H2v2h10.2l-2.6,2.6L11,17l5-5L11,7z M20,19h-8v2h8c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2h-8v2h8V19z"/></g></svg>
														<div class="fs-13">Abmelden</div>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--/app header-->
				<!-- global Search -->
				<v-card id="megaMenuCard"  class="pl-5 pr-5 pt-2">
						<b-container class="p-0">
							<b-row>
								<b-col>
									<label class="custom-control custom-checkbox">
										<input v-model="checkBoxes.user" type="checkbox" class="custom-control-input"/>
										<span class="custom-control-label">Benutzer</span>
									</label>
									<!-- <input type="checkbox" id="checkboxUser" ><label for="checkboxUser" class="text-light ml-1">Benutzer</label> -->
								</b-col>
								<b-col>
									<label class="custom-control custom-checkbox">
										<input v-model="checkBoxes.events" type="checkbox" class="custom-control-input"/>
										<span class="custom-control-label">Ereignisse</span>
									</label>
									<!-- <input type="checkbox" id="checkboxEvents" v-model="checkBoxes.events"><label for="checkboxEvents" class="text-light ml-1">Ereignisse</label> -->
								</b-col>
								<b-col>
									<label class="custom-control custom-checkbox">
										<input v-model="checkBoxes.trips" type="checkbox" class="custom-control-input"/>
										<span class="custom-control-label">Touren</span>
									</label>
									<!-- <input type="checkbox" id="checkboxTrips" v-model="checkBoxes.trips"><label for="checkboxTrips" class="text-light ml-1">Trips</label> -->
								</b-col>
								<b-col>
									<label class="custom-control custom-checkbox">
										<input v-model="checkBoxes.posts" type="checkbox" class="custom-control-input"/>
										<span class="custom-control-label">Beiträge</span>
									</label>
									<!-- <input type="checkbox" id="checkboxPosts" v-model="checkBoxes.posts"><label for="checkboxPosts" class="text-light ml-1">Beiträge</label> -->
								</b-col>
								<!-- Belohnungen deaktiviert (Ronny, 2026-08-05): v-if entfernen zum Reaktivieren -->
								<b-col v-if="false">
									<label class="custom-control custom-checkbox">
										<input v-model="checkBoxes.rewards" type="checkbox" class="custom-control-input"/>
										<span class="custom-control-label">Belohnungen</span>
									</label>
								</b-col>
								
							</b-row>
						</b-container>
					<div class="card" v-if="checkBoxes.user">
						<v-card-title>Benutzer</v-card-title>
						<div class="table-responsive table-hover" v-if="userSearch.length > 0">
							<table class="table card-table table-vcenter text-nowrap">
								<thead>
									<th>Profilbild</th>
									<th>Benutzername</th>
									<th>E-Mail</th>
								</thead>
								<tbody>
									<tr class="clickableTable " v-for="user in userSearch" :key="user._id" @click="openSearchResult('Users', {user: user})">
										<td class="align-middle"><img :src="`${$img(user.image,$awsSmallImages)}`" alt="img" class="avatar avatar-md brround"></td>
										<td class="align-middle">{{user.userName}}</td>
										<td class="align-middle tableAbout">{{user.email}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<v-card-text v-else>Keine Benutzer gefunden</v-card-text>
					</div>
					<div class="card" v-if="checkBoxes.events">
						<v-card-title>Ereignisse</v-card-title>
						<div class="table-responsive table-hover" v-if="eventSearch.length > 0">
							<table class="table card-table table-vcenter text-nowrap">
								<thead>
									<th>Bild</th>
									<th>Name</th>
									<th>Datum</th>
								</thead>
								<tbody>
									<tr class="clickableTable" v-for="event in eventSearch" :key="event._id" @click="openSearchResult('Events', {event: event})">
										<td class="align-middle"><img :src="`${$img(event.image,$awsSmallImages)}`" alt="img" class="avatar avatar-md brround"></td>
										<td class="align-middle tableAbout">{{event.title}}</td>
										<td class="align-middle">{{$formatDate(event.eventDate)}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<v-card-text v-else>Keine Ereignisse gefunden</v-card-text>
					</div>
					<div class="card" v-if="checkBoxes.trips">
						<v-card-title>Touren</v-card-title>
						<div class="table-responsive table-hover" v-if="tripSearch.length > 0">
							<table class="table card-table table-vcenter text-nowrap">
								<thead>
									<th>Bild</th>
									<th>Name</th>
									<th>Datum</th>
								</thead>
								<tbody>
									<tr class="clickableTable" v-for="trip in tripSearch" :key="trip._id" @click="openSearchResult('Trips', {trip: trip})">
										<td class="align-middle"><img :src="`${$img(trip.image,$awsSmallImages)}`" alt="img" class="avatar avatar-md brround"></td>
										<td class="align-middle tableAbout">{{trip.title}}</td>
										<td class="align-middle">{{$formatDate(trip.tripDate)}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<v-card-text v-else>Keine Touren gefunden</v-card-text>
					</div>
					<div class="card" v-if="checkBoxes.posts">
						<v-card-title>Beiträge</v-card-title>
						<div class="table-responsive table-hover" v-if="postSearch.length > 0">
							<table  class="table card-table table-vcenter text-nowrap">
								<thead>
									<th>Bild</th>
									<th>Benutzername</th>
									<th>Beschreibung</th>
								</thead>
								<tbody>
									<tr class="clickableTable" v-for="post in postSearch" :key="post._id" @click="openSearchResult('Posts', {post: post})">
										<!-- Ein Beitrag ohne Bild ließ zuvor die gesamte Oberfläche weiß werden:
										     Der Zugriff auf das erste Element wirft, und weil das hier in der
										     Wurzelkomponente steht, reißt es auch die Seitenansicht mit. -->
										<td class="align-middle"><img :src="`${$img(firstImage(post), $awsSmallImages)}`" alt="" class="avatar avatar-md brround"></td>
										<td class="align-middle">{{ post.user ? post.user.userName : 'Unbekannt' }}</td>
										<td class="align-middle tableAbout">{{post.description}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<v-card-text v-else>Keine Beiträge gefunden</v-card-text>
					</div>
					<div class="card" v-if="checkBoxes.rewards">
						<v-card-title>Belohnungen</v-card-title>
						<div class="table-responsive table-hover" v-if="rewardSearch.length > 0">
							<table class="table card-table table-vcenter text-nowrap">
								<thead>
									<th>Bild</th>
									<th>Titel</th>
									<th>Beschreibung</th>
									<th>Typ</th>
								</thead>
								<tbody>
									<tr class="clickableTable" v-for="reward in rewardSearch" :key="reward._id" @click="openSearchResult('Rewards', {reward: reward})">
										<td class="align-middle"><img :src="`${$img(reward.image,$awsSmallImages)}`" alt="img" class="avatar avatar-md brround"></td>
										<td class="align-middle">{{reward.title}}</td>
										<td class="align-middle tableAbout">{{reward.category}}</td>
										<td class="align-middle">
											<div v-if="reward.type=='address'"> Adresse</div>
											<div v-if="reward.type=='email'"> E-Mail</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<v-card-text v-else>Keine Belohnungen gefunden</v-card-text>
					</div>
				</v-card>
				<v-overlay :value="overlay" :opacity="0.5"></v-overlay>

	<!-- Router View -->
				<router-view></router-view>
			</div>
		</div>
		<!-- End app-content-->


		<!--Footer-->
		<!-- <footer class="footer">
			<div class="container">
				<div class="row align-items-center flex-row-reverse">
					<div class="col-md-12 col-sm-12 text-center">
						Copyright © 2021 <a href="javascript:void(0);">azea</a>. Designed with <span class="fa fa-heart text-danger"></span> by <a href="javascript:void(0);"> Spruko </a> All rights reserved
					</div>
				</div>
			</div>
		</footer> -->
		<!-- End Footer-->
	</div>

	
    </v-app>

	
		
	
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      // Aufbau des Seitenmenüs. Nach Themen gruppiert, damit man nicht in einer
      // langen Liste sucht; die Beschriftungen benennen den Inhalt statt der
      // technischen Bezeichnung ("Rundnachricht" statt "Broadcast").
      menuSections: [
        {
          title: "Übersicht",
          entries: [
            {
              label: "Startseite",
              icon: "fas fa-home",
              route: "dashboard",
              hint: "Zahlen und Auswertungen auf einen Blick",
            },
          ],
        },
        {
          title: "Mitglieder",
          entries: [
            {
              label: "Benutzer",
              icon: "fas fa-users",
              route: "users",
              hint: "Alle Mitglieder mit ihrer Aktivität",
            },
            {
              // Steht unter "Mitglieder" und nicht unter "Inhalte": Eine Gruppe
              // ist ein Zusammenschluss von Nutzern, kein Inhalt wie ein Beitrag
              // oder eine Tour. Wer sie sucht, sucht sie bei den Menschen.
              label: "Gruppen",
              icon: "fas fa-user-friends",
              route: "crews",
              hint: "Alle Gruppen mit ihren Mitgliedern",
            },
            {
              label: "Meldungen",
              icon: "fas fa-exclamation-triangle",
              route: "reported",
              hint: "Gemeldete Nutzer und Inhalte prüfen",
            },
          ],
        },
        {
          title: "Inhalte",
          entries: [
            {
              label: "Beiträge",
              icon: "fas fa-images",
              route: "posts",
              hint: "Was die Mitglieder geteilt haben",
            },
            {
              label: "Neuigkeiten",
              icon: "fas fa-newspaper",
              route: "newsmessages",
              hint: "Meldungen, die in der App erscheinen",
            },
            {
              label: "Veranstaltungen",
              icon: "fas fa-calendar-alt",
              route: "events",
              hint: "Treffen und Termine",
            },
            {
              label: "Touren",
              icon: "fas fa-road",
              route: "trips",
              hint: "Gefahrene Strecken der Mitglieder",
            },
            {
              label: "Routen",
              // WAR FALSCH: "fa-route" gibt es erst ab FontAwesome 5.2.0 —
              // eingebunden ist hier 5.0.13 (public/css/fa5-all.css), das
              // Symbol wäre unsichtbar geblieben. "fa-location-arrow" ist im
              // Set enthalten und passt inhaltlich zu GPS-Aufzeichnungen.
              icon: "fas fa-location-arrow",
              route: "routes",
              hint: "Mit der Streckenaufzeichnung angelegte Routen",
            },
            {
              label: "Tourvorlagen",
              icon: "fas fa-map-signs",
              route: "predefinedTrips",
              hint: "Vorgefertigte Strecken zum Nachfahren",
            },
          ],
        },
        {
          title: "Mitteilungen",
          entries: [
            {
              label: "Rundnachricht",
              icon: "fas fa-bullhorn",
              route: "broadcast",
              hint: "Mitteilung an alle Nutzer schicken",
            },
          ],
        },
        {
          title: "Einstellungen",
          entries: [
            // Belohnungen deaktiviert (Ronny, 2026-08-05): werden nicht mehr
            // gebraucht. Seite und Route bleiben bestehen, nur der Weg dorthin
            // ist zu. Zum Reaktivieren diesen Eintrag wieder einhängen:
            // { label: "Belohnungen", icon: "fas fa-shopping-cart", route: "rewards" },
            //
            // Level deaktiviert (Ronny, 2026-08-06): gehört zum selben
            // abgeschalteten Münz- und Stufensystem wie die Belohnungen darüber
            // und blieb beim letzten Mal versehentlich stehen. Gemessen:
            //   · Die App ruft KEINEN einzigen `/level`-Endpunkt auf.
            //   · Von allen Level-Daten benutzt sie ein einziges Feld
            //     (`nextLevelImage`, profile_page.dart) — und das nur im
            //     Sonst-Zweig von `profile_header.dart`, wenn keine
            //     Rangplatzierung vorliegt. Die kleinste Platzierung über alle
            //     35 Konten ist 1; der Fall tritt also nur ein, wenn die
            //     Rangabfrage scheitert.
            //   · Der Bearbeiten-Knopf der Seite brach ohnehin mit 422 ab: Sie
            //     schickt ein Feld mit, das die Eingabeprüfung nicht zulässt.
            //   · Keines der 10 vorhandenen Level stammt aus dem Dashboard —
            //     alle wurden am 10.07. in derselben Sekunde von einem Skript
            //     geschrieben, das nicht im Repository liegt.
            //
            // Seite und Route bleiben bestehen, nur der Weg dorthin ist zu.
            // Das Backend vergibt weiterhin Level (helpers/utils.js und
            // userController.js) — daran ändert dieser Eintrag nichts.
            // Zum Reaktivieren: erst den 422-Fehler beheben, sonst ist die
            // Seite nur Dekoration.
            // {
            //   label: "Level",
            //   icon: "fas fa-trophy",
            //   route: "levels",
            //   hint: "Stufen und Schwellenwerte",
            // },
            // Die beiden Fahrzeug-Seiten werden leicht verwechselt, deshalb
            // sagen die Hinweistexte ausdrücklich, was worin steht:
            //
            //   „Fahrzeuge & Marken"    = der KATALOG. Alle Fahrzeuge, die es
            //                             gibt — daraus wählt ein Mitglied in
            //                             der App sein eigenes Fahrzeug aus.
            //   „Fahrzeuge der Nutzer"  = die EINGETRAGENEN Fahrzeuge der
            //                             Mitglieder, also das Ergebnis
            //                             dieser Auswahl.
            //
            // Wer den Katalog für die Mitgliederfahrzeuge hält, löscht dort
            // im Zweifel den falschen Eintrag — deshalb steht der Unterschied
            // in der Oberfläche und nicht nur hier im Code.
            {
              label: "Fahrzeuge & Marken",
              icon: "fas fa-car",
              route: "models",
              hint: "Katalog zur Auswahl im App-Profil",
            },
            // WAR FALSCH: Dieser Eintrag fehlte. Die Seite existiert seit
            // jeher (main.js: `{ path: "/userAutos", … }`), war aber über
            // KEINEN Weg im Dashboard erreichbar — kein Menüpunkt, kein
            // Verweis, kein Knopf. Nur wer die Adresse von Hand eintippte,
            // kam hin.
            //
            // Das wiegt schwer, weil auf dieser Seite gelöscht werden kann:
            // Sie zeigt die tatsächlich eingetragenen Fahrzeuge aller
            // Mitglieder samt Löschen-Knopf. Eine Verwaltungsfunktion, von
            // der niemand wusste, dass es sie gibt.
            //
            // Kein Versehen beim Aufräumen: Für die drei bewusst
            // abgeschalteten Seiten (Prämien, Stufen) steht die
            // Deaktivierung ausdrücklich mit Datum im Code, ein paar Zeilen
            // weiter oben. Für „userAutos" gibt es nichts dergleichen — der
            // Eintrag hat schlicht nie existiert.
            //
            // Steht bewusst direkt unter „Fahrzeuge & Marken" — siehe die
            // Abgrenzung der beiden Seiten weiter oben.
            {
              label: "Fahrzeuge der Nutzer",
              icon: "fas fa-car-side",
              route: "userAutos",
              hint: "Von Mitgliedern eingetragene Fahrzeuge",
            },
            {
              label: "App-Versionen",
              icon: "fas fa-mobile-alt",
              route: "versions",
              hint: "Welche Fassung die Nutzer brauchen",
            },
          ],
        },
      ],

      drawer:null,
      footdrawer:true,
      selectedlanguage:null,
      possiblelanguages: [],
      // ENTFERNT: standardRoutes, loginRoute, logoutRoute, allowedRoutes.
      // WAR FALSCH: Dieser Block war toter Code — nirgends in der Vorlage
      // gelesen (das tatsächliche Menü kommt aus menuSections weiter oben).
      // Zwei seiner fünf $t(...)-Aufrufe ("objects", "masterdata") zeigten auf
      // Schlüssel, die es in messages.json nie gab, und lösten deshalb bei
      // jedem Laden zwei Übersetzungs-Warnungen in der Entwicklerkonsole aus
      // (vue-i18n.common.js:1541). Sichtbar war davon nichts — die Warnungen
      // verwirrten nur beim Suchen nach echten Fehlern.
      user: null,
      language: {
        language: null,
        flag: null,
        shortForm: null
      },
      languages: [],
	  search: '',
	  megaMenu: false,
	  userSearch: [],
	  eventSearch: [],
	  tripSearch: [],
	  postSearch: [],
	  rewardSearch: [],
	  levelSearch: [],
	  postSearch: [],
	  overlay: false,
	  checkBoxes: {
		  user: true,
		  events: true,
		  trips: true,
		  posts: true,
		  // Belohnungen deaktiviert (Ronny, 2026-08-05). Dieser Schalter steuert
		  // zugleich die Suchabfrage und die Ergebnisliste — beides bleibt damit aus.
		  rewards: false
	  }
    };
  },

  mounted() {
	if(!window.location.href.includes("/app")) {
		this.getCurrentUser();
	}
  },

  computed: {
    mini() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },

  methods: {
	/**
	 * Erstes Bild eines Beitrags — mit Absicherung.
	 *
	 * Ein Beitrag kann ohne Bild vorliegen; der direkte Zugriff auf das erste
	 * Element warf dann und ließ die gesamte Oberfläche weiß werden, weil das
	 * Suchergebnis in der Wurzelkomponente steht.
	 */
	firstImage(post) {
		if (!post || !post.galleryImages || post.galleryImages.length === 0) return '';
		return post.galleryImages[0].url;
	},

	/**
	 * Markiert den Eintrag der gerade geöffneten Seite.
	 * Der mitgelieferte jQuery-Code dafür lief einmalig beim Seitenladen und
	 * verglich echte Adressen — bei einer Anwendung ohne Seitenwechsel und
	 * href="javascript:void(0)" konnte er nie greifen.
	 */
	isActiveRoute(route) {
		return this.$route.path.toLowerCase() === '/' + route.toLowerCase();
	},

	/**
	 * Wechselt die Seite. Ohne die Prüfung wirft der Router beim Klick auf den
	 * bereits geöffneten Eintrag einen Fehler in die Konsole.
	 */
	goToRoute(route) {
		if (this.isActiveRoute(route)) return;
		this.$router.push(route);
	},

	log(){
		console.log('con');
	},
    getCurrentUser() {
		var _this = this;
     	this.$axios.get("/user/profile/my/0/5").then(function(response){
			// FEHLER 4 (dasselbe Muster wie in Login.vue und main.js): Lehnt
			// der Server den Profilabruf fachlich ab (HTTP 200,
			// success:false), stand hier ungeprüft response.data.data, also
			// undefined, in $user. "$user != null" oben im Template ist bei
			// undefined ebenso falsch wie bei null — Menü und Kopfleiste
			// verschwanden lautlos, ohne jede Meldung.
			if (response.data == null || response.data.success === false) {
				console.warn("Profilabruf abgelehnt:", response.data && response.data.message);
				// WAR FALSCH: Nur $user=null gesetzt, keine Weiterleitung. Der
				// Verwalter blieb auf einer Seite ohne Menü und Kopfleiste stehen
				// (dasselbe FEHLER-4-Muster wie in Login.vue/main.js), nur diesmal
				// über den $route-Watcher nach dem Login statt über mounted().
				// JETZT: switchToLoginPage() macht dasselbe wie main.js/beforeMount
				// an vergleichbarer Stelle — Zugangsschlüssel entfernen, Nutzer
				// zurücksetzen, zur Anmeldeseite weiterleiten.
				_this.switchToLoginPage();
				return;
			}
			const user = response.data.data;
			Vue.prototype.$user = user;
			_this.$forceUpdate();
		})
		.catch(function(error){
			console.error(error);
		});
    },
    
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },

    /**
     * FEHLER 6: Gemeinsame Absicherung für die fünf Suchabfragen in
     * globalSearch(). War ohne Erfolgsprüfung — response.data.data wurde
     * ungeprüft in die jeweilige Ergebnisliste geschrieben. Lehnt der Server
     * ab (HTTP 200, success:false), fehlt data, die Liste wurde also
     * "undefined". Die Vorlage liest an jeder Stelle ".length > 0" darauf
     * ("v-if=userSearch.length > 0" usw.) — das griff auf undefined.length zu
     * und riss die gesamte Suchkarte beim Zeichnen ab, nicht nur den
     * betroffenen Reiter.
     */
    searchResult(response, label) {
      if (response.data == null || response.data.success === false) {
        const message = response.data && response.data.message;
        this.$noty.error(message || ('Suche nach ' + label + ' ist fehlgeschlagen.'));
        return [];
      }
      return response.data.data || [];
    },

    logout() {
      this.$axios
        .get("/signOut")
        .then(this.logoutDone)
        .catch(this.logoutFailed);
    },
    logoutDone(response) {
      this.switchToLoginPage();
    },
    logoutFailed(error) {
      this.switchToLoginPage();
    },
    switchToLoginPage() {
	  this.$router.push("login");
      Vue.prototype.$user = null;
      localStorage.setItem("id_token", "");
    },
	globalSearch() {
		let _this = this;

		// Der Suchbegriff ist Teil des Pfades und muss deshalb ueberall durch
		// encodeURIComponent. Ohne das zerlegte schon ein einzelnes "/" oder "?"
		// in der Suchleiste den Pfad: Aus /user/search/a/b/0/5/-1 wurde eine
		// Route, die es nicht gibt — alle fuenf Abfragen der globalen Suche
		// endeten dann in einem 404 und die Vorschlagsliste blieb leer.
		const searchTerm = encodeURIComponent(this.search);

		// Search for Users
		if(this.checkBoxes.user) {
			// WAR FALSCH: /user/search/... ist der offene Endpunkt für Nutzer
			// innerhalb der App (z. B. Follower suchen) — der filtert Konten
			// ohne lastActive (nie aktiv genutzte/private Testkonten) still-
			// schweigend heraus. Im Dashboard, das als Verwaltung ohnehin nur
			// mit Admin-Rechten läuft, gehört /user/admin/search/... aufgerufen
			// (searchUserAsAdmin), das genau diesen Fall extra abfängt.
			this.$axios.get('/user/admin/search/' + searchTerm +'/0/5/-1').then(function(response){
				_this.userSearch = _this.searchResult(response, 'Benutzer');
			}).catch(function(error){
				_this.userSearch = [];
				_this.onError(error);
			});
		}

		// Search for Events
		if(this.checkBoxes.events){
			this.$axios.get("/event/search/" + searchTerm + "/0/5/-1")
			.then(function (response) {
			  _this.eventSearch = _this.searchResult(response, 'Ereignisse');
			})
			.catch(function (error) {
			  _this.eventSearch = [];
			  _this.onError(error);
			});
		}

		// Search for Trips
		if(this.checkBoxes.trips){
			this.$axios.get("/trip/search/" + searchTerm + "/0/5/-1")
			.then(function (response) {
			  _this.tripSearch = _this.searchResult(response, 'Touren');
			})
			.catch(function (error) {
			  _this.tripSearch = [];
			  _this.onError(error);
			});
		}

		// Search for Rewards
		if(this.checkBoxes.rewards){
			this.$axios.get("/reward/search/" + searchTerm + "/0/5")
			.then(function (response) {
			  _this.rewardSearch = _this.searchResult(response, 'Belohnungen');
			})
			.catch(function (error) {
			  _this.rewardSearch = [];
			  _this.onError(error);
			});
		}

		// Search for Posts
		if(this.checkBoxes.posts){
			this.$axios.get("/post/search/" + searchTerm + "/0/5/-1")
			.then(function (response) {
			  _this.postSearch = _this.searchResult(response, 'Beiträge');
			})
			.catch(function (error) {
			  _this.postSearch = [];
			  _this.onError(error);
			});
		}

		
		document.addEventListener('keyup', function (event) {
			if(event.code == 'Escape') { 
				_this.closeSearchMenu();
			}
		})
	},

	openSearchResult(name, params) {
		if(this.$route.name == name) {
			if(name == 'Users'){
				this.$root.$emit('Users', params.user);
			} else if(name == 'Events') {
				this.$root.$emit('Events', params.event);
			} else if(name == 'Trips') {
				this.$root.$emit('Trips', params.trip);
			} else if(name == 'Posts') {
				this.$root.$emit('Posts', params.post);
			} else if(name == 'Rewards') {
				this.$root.$emit('Rewards', params.reward);
			}
			this.closeSearchMenu();
		} else {
			this.$router.push({name: name, params: params});
		}
	},

	openSearchMenu() {
		document.getElementById('megaMenuCard').setAttribute('style', "visibility: visible");
		this.overlay = true;
	},
	closeSearchMenu() {
		document.getElementById('megaMenuCard').setAttribute('style', "visibility: hidden");
			this.search = "";
			this.overlay = false;
	}

  },
  watch: {
    $route(to, from) {
      if (from.path === "/login" && to.path !== "/reset-password") {
        this.getCurrentUser();
      }
	  this.closeSearchMenu();
    },
	search: function () {
      if (this.search == "") {
        this.closeSearchMenu();
      } else {
		  if(this.search.length > 1) {
			this.openSearchMenu();
			this.globalSearch();
		}
      }
    },
	checkBoxes: {
		handler() {
			this.globalSearch();
		},
		deep: true,
	},
  },
};
</script>

<style scoped>
/*
 * Menüschalter am Seitenstreifen: sitzt rechts im Logo-Bereich, damit er beim
 * Menü steht, das er auf- und zuklappt.
 */
.app-sidebar__logo {
	position: relative;
}

.sidebar-toggle-left {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	padding: 6px 10px;
	cursor: pointer;
	opacity: 0.75;
}

.sidebar-toggle-left:hover {
	opacity: 1;
}

/*
 * Eingeklappt ist der Streifen nur so breit wie das Zeichen — dort liefe der
 * Schalter über das Logo. Er erscheint wieder, sobald die Maus den Streifen
 * berührt und dieser sich öffnet.
 */
body.sidenav-toggled .app-sidebar:not(:hover) .sidebar-toggle-left {
	display: none;
}

/*
 * Menü weiter nach oben.
 *
 * Die Vorlage setzt `.side-menu { margin-top: 90px }` (public/css/style.css, Regel ab Zeile 48266).
 * Der Logo-Block endet bei 71 Pixeln, das erste Menüwort begann dadurch erst
 * bei 161 — neunzig Pixel Leerraum, in denen nichts steht.
 *
 * WARUM DIE VORLAGE DEN ABSTAND BRAUCHTE — und wir nicht mehr:
 * Dort ist `.app-sidebar__logo` auf `position: fixed` gesetzt
 * (style.css:49063, Regel ab 49056). Ein festes Element liegt außerhalb des normalen Flusses,
 * die Liste würde also darunter rutschen; die 90 Pixel hielten den Platz frei.
 * Weiter oben in dieser Datei steht seit dem Menüschalter aber
 * `.app-sidebar__logo { position: relative }` — das Logo steht wieder im Fluss
 * und schiebt die Liste von selbst nach unten. Der Abstand war seitdem
 * doppelt gemoppelt.
 *
 * WAS ER KOSTETE: `.app-sidebar` ist `position: fixed` ohne `overflow-y`
 * (style.css, Regel ab 48161). Was unten nicht mehr hineinpasst, ist nicht scrollbar,
 * sondern schlicht weg. Neunzig Pixel oben sind also neunzig Pixel weniger
 * Menü unten.
 *
 * WARUM HIER UND NICHT IN DER VORLAGE: `public/css/style.css` ist das gekaufte
 * Gerüst („Azea", 52.522 Zeilen, seit dem ersten Commit unverändert). Wer es
 * anfasst, verliert die Änderung beim nächsten Austausch. Dieser Block ist
 * `scoped`; Vue hängt an jede Regel darin das Kennzeichen der Komponente, und
 * die höhere Genauigkeit sticht die Vorlage.
 *
 * KEIN EINGRIFF AUF SCHMALEN BILDSCHIRMEN: Unter 768 Pixeln setzt die Vorlage
 * `margin-top: 0 !important` (style.css:47827). Das `!important` gewinnt
 * unabhängig von der Genauigkeit — dort bleibt alles, wie es war.
 *
 * Die beiden Zusatz-Selektoren stehen vorsorglich da: `.closed-menu` und
 * `.icontext-menu` sind zwei Menüvarianten der Vorlage, die dieses Projekt
 * derzeit NICHT benutzt (der body trägt nur `app sidebar-mini dark-mode`, siehe
 * public/index.html). Sie greifen also heute nicht — falls jemand eine der
 * Varianten einschaltet, springt das Menü dann aber nicht zurück auf 90.
 */
.side-menu,
.closed-menu .side-menu,
.icontext-menu .side-menu {
	margin-top: 16px;
}
</style>

<!--
	Dieser Block ist bewusst NICHT `scoped`.

	`scoped` hängt an jede Regel eine Kennung der Komponente und begrenzt sie
	damit auf deren eigenes Markup — die Überschriften stehen aber in den
	Unterseiten, nicht hier. Ohne `scoped` gilt der Block für das ganze
	Dashboard, und weil App.vue immer geladen ist, greift er auf jeder Seite.

	Warum hier und nicht in der Vorlage: `public/css/style.css` hat 52.522
	Zeilen und ist gekauft — bei einem Update wird sie überschrieben und jede
	Änderung darin wäre weg. Dieser Block überlebt das, weil der Baukasten die
	Stile der Komponenten NACH allen Vorlagendateien einbindet.
-->
<style>
/*
 * Überschriften auf eine Größe bringen.
 *
 * Vorgefunden waren zwei Größen: Seitentitel 20 px (`.page-title`,
 * style.css:13456), Kartentitel 13 px (`.card-title`, style.css:34256).
 * Beide behalten ihre übrigen Eigenschaften — die Großschreibung der
 * Kartentitel bleibt ausdrücklich erhalten, sie trennt die Ebenen weiterhin
 * voneinander, ohne mit der Größe zu arbeiten.
 *
 * `.card-title` kommt im Dashboard 16-mal vor, keine dieser Stellen liegt in
 * einem Dialog — nachgezählt. Dialogköpfe benutzen `.page-title` innerhalb von
 * `v-card-title` und sind von dieser Regel deshalb nicht berührt.
 */
.card-title {
	font-size: 20px;
	line-height: 1.4;
}

/*
 * Der Seitentitel bekommt dieselbe Größe UND dieselbe Großschreibung wie die
 * Kartentitel. Damit sehen alle Überschriften im Dashboard gleich aus.
 *
 * Der Selektor ist bewusst zweiteilig: `.page-title` allein käme 58-mal vor,
 * aber nur rund 20 davon sind Seitentitel — der Rest sind Dialogköpfe
 * („Ereignis bearbeiten", „Wirklich löschen?"). Die stecken in `v-card-title`,
 * die Seitentitel in `.page-header`. Wer hier `.page-title` ohne Vorsatz
 * schreibt, schreit den Nutzer in jedem Bestätigungsdialog an.
 *
 * `text-transform` ändert nur die Darstellung, nicht den Text: Im Quelltext
 * steht weiterhin „Gruppen", und wer die Überschrift markiert und kopiert,
 * bekommt „Gruppen" — nicht „GRUPPEN".
 */
.page-header .page-title {
	font-size: 20px;
	text-transform: uppercase;
}

/*
 * Erklärtexte unter der Überschrift.
 *
 * Vorgefunden waren zwei Muster: `page-subtitle` auf den Seiten Rundnachricht,
 * Neuigkeiten und Meldungen (13 px, rgb(110,118,135)) und `text-muted` auf der
 * Gruppen-Seite (16 px, rgba(204,212,224,0.5)). Der Unterschied fällt kaum auf,
 * solange man die Seiten nicht nebeneinander hält — dann aber sofort.
 *
 * Alle vier nutzen jetzt `page-subtitle`, und diese Regel setzt darauf die
 * hellere, größere Fassung. Sie ist die besser lesbare: 13 px in einem
 * gedämpften Grau verschwindet auf dem dunklen Hintergrund fast.
 */
.page-subtitle,
.dark-mode .page-subtitle {
	font-size: 16px;
	color: rgba(204, 212, 224, 0.5);
	line-height: 1.5;
}

/*
 * Der Erklärtext muss auch auf schmalen Bildschirmen sichtbar bleiben.
 *
 * Die gekaufte Vorlage blendet ihn ab 768 px Breite vollständig aus
 * (`public/css/style.css:8499`, `.page-subtitle { display: none }`). Das ist
 * kein Verkleinern, sondern ein Entfernen: Der Satz, der erklärt, was die Seite
 * tut, ist auf dem Telefon einfach weg.
 *
 * Aufgefallen ist das erst durch die Vereinheitlichung: Die Gruppen-Seite nutzte
 * vorher `text-muted`, das keine solche Regel hat. Ohne diese Rücknahme hätte
 * ausgerechnet die Umstellung auf die gemeinsame Klasse dort Text gekostet.
 *
 * Die Media-Query muss wiederholt werden — eine Regel ohne `display` kann eine
 * fremde `display: none` nicht zurücknehmen, egal wie spät sie geladen wird.
 */
@media (max-width: 768px) {
	.page-subtitle,
	.dark-mode .page-subtitle {
		display: block;
		font-size: 15px;
	}
}
</style>
